import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import Instrumentos from './pages/Instrumentos';
import Calendario from './pages/Calendario';
// import Usuarios from './pages/Usuarios';
import NuevoInstrumento from './pages/NuevoInstrumento';
import EditarInstrumento from './pages/EditarInstrumento';
import HistorialCambios from './pages/HistorialCambios';
import Login from './pages/Login';
import EmpresasPage from './pages/EmpresasPage';
import ResetPassword from './pages/ResetPassword';
import NuevaEmpresaAdmin from './pages/admin/NuevaEmpresaAdmin';
import ProtectedRoute from './components/ProtectedRoute';
import SuperadminRoute from './components/SuperadminRoute';
import Dashboard from "./pages/Dashboard";

import { supabase } from './services/supabaseClient';
import { loadAndCacheUser } from './services/sessionService';
//import { hydrateSessionFromSupabase, initAuthListener } from './services/sessionService';
//import { runManualDocumentIntelligenceTest } from './document-intelligence/tests/manual-test';
import NotFound from './pages/NotFound';

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  
  // 🔹 Mantener `user` reactivo con Supabase y cambios en storage
  useEffect(() => {
  let mounted = true;

  const initializeAuth = async () => {
    const { data, error } = await supabase.auth.getSession();

    if (!mounted) return;

    if (error || !data?.session?.user) {
      localStorage.removeItem('user');
      setUser(null);
      setAuthLoading(false);
      return;
    }

    const perfil = await loadAndCacheUser(data.session.user);

    if (!mounted) return;

  if (!perfil) {
    await supabase.auth.signOut();
    setUser(null);
    setAuthLoading(false);
    return;
  }

  setUser(perfil);
  setAuthLoading(false);
  };

  initializeAuth();

  const { data } = supabase.auth.onAuthStateChange((_event, session) => {
    if (!mounted) return;

    if (!session?.user) {
      localStorage.removeItem('user');
      setUser(null);
      setAuthLoading(false);
      return;
    }

    // El perfil de SmartGage se actualiza fuera del callback.
    setTimeout(async () => {
      if (!mounted) return;

      const perfil = await loadAndCacheUser(session.user);

      if (!mounted) return;

      if (!perfil) {
        await supabase.auth.signOut();
        setUser(null);
        setAuthLoading(false);
        return;
      }

      setUser(perfil);
      setAuthLoading(false);
    }, 0);
  });

  return () => {
    mounted = false;
    data.subscription.unsubscribe();
  };
}, []);
 
  // 🔹 Prueba manual temporal del motor Document Intelligence
  //useEffect(() => {
  //  runManualDocumentIntelligenceTest();
  //}, []);

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
        <div className="rounded-2xl border border-slate-200 bg-white px-6 py-5 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="h-2.5 w-2.5 animate-pulse rounded-full bg-cyan-500" />

            <p className="text-sm font-medium text-slate-600">
              Verificando sesión...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className={user ? "min-h-screen bg-slate-100" : "min-h-screen"}>
        <Navbar user={user} />

        <Routes>
        <Route
          path="/login"
          element={
            user
              ? <Navigate to="/" replace />
              : <Login onLogin={setUser} />
     }
   />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Rutas protegidas */}
       <Route
          path="/instrumentos"
          element={
            <ProtectedRoute user={user}>
              <Instrumentos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/calendario"
          element={
            <ProtectedRoute user={user}>
              <Calendario />
            </ProtectedRoute>
          }
        />

        <Route
          path="/historial"
          element={
            <ProtectedRoute user={user}>
              <HistorialCambios />
            </ProtectedRoute>
          }
        />

        <Route
          path="/instrumentos/nuevo"
          element={
            <ProtectedRoute user={user}>
              <NuevoInstrumento />
            </ProtectedRoute>
          }
        />
        <Route
          path="/instrumentos/editar/:id"
          element={
            <ProtectedRoute user={user}>
              <EditarInstrumento />
            </ProtectedRoute>
          }
        />
        <Route
          path="/empresas"
          element={
            <ProtectedRoute user={user}>
              <EmpresasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute user={user}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* Solo superadmin */}
        <Route
          path="/admin/nueva-empresa"
          element={
            <SuperadminRoute user={user}>
              <NuevaEmpresaAdmin />
            </SuperadminRoute>
          }
        />

        {/* catch-all */}
        <Route
          path="*"
          element={
            <ProtectedRoute user={user}>
              <NotFound />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  </Router>
);
}

export default App;